import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import initializeWeekStartOptionViewState from '../../actions/weekStart/initializeWeekStartOptionViewState';
import WeekStartViewState from '../../store/schema/WeekStartViewState';
import { getOptionsStore } from '../../store/Store';
import { getOwaDatetimeStrings } from 'owa-strings/owa-datetime-strings';
import { mutator } from 'satcheljs';

const initializeWeekStartOptionViewStateMutator = mutator(
    initializeWeekStartOptionViewState,
    actionMessage => {
        const store = getOptionsStore();
        const dateTimeStrings = getOwaDatetimeStrings();
        if (store) {
            const viewState: WeekStartViewState = {
                name: ActiveItem.WeekStart,
                isLoading: true,
                isDirty: false,
                WeekStartDay: getUserConfiguration().UserOptions?.WeekStartDay,
                WeekStartOptions: [
                    dateTimeStrings.calendarDayOfWeek_Sunday, // Always maintain this at 0 since 0 is a sunday
                    dateTimeStrings.calendarDayOfWeek_Monday,
                    dateTimeStrings.calendarDayOfWeek_Tuesday,
                    dateTimeStrings.calendarDayOfWeek_Wednesday,
                    dateTimeStrings.calendarDayOfWeek_Thursday,
                    dateTimeStrings.calendarDayOfWeek_Friday,
                    dateTimeStrings.calendarDayOfWeek_Saturday,
                ],
            };
            store.activeViewState = viewState as ActiveOptionViewState;
        }
    }
);

// exported only for testing purposes
export default initializeWeekStartOptionViewStateMutator;
